/**
 * Wire types for /coach/admin/email-test-send/*.
 *
 * `sampleVars` KEYS are snake_case on purpose — they are Mandrill
 * merge-variable names (`reset_url`), echoed straight back from
 * `GET /templates`. They are data, not DTO fields, so the backend's
 * camelCase serializer does not touch them and neither should we.
 *
 * There are no render types. ADR-0051 moved email bodies into Mailchimp,
 * so the API has no subject, HTML or text to return.
 */

export interface SampleVar {
  name: string
  /** Form default. NOT an optionality signal — every merge variable a
   * template declares is mandatory, because a blank one renders as an
   * empty string at Mandrill rather than failing. */
  example: string
}

export interface SendableEmail {
  key: string
  label: string
  sampleVars: SampleVar[]
}

export interface TemplatesResponse {
  templates: SendableEmail[]
  /** Domains a test send may target, resolved server-side. Displayed so
   * the operator isn't guessing which addresses are legal. */
  allowedRecipientDomains: string[]
}

export interface SendTestRequest {
  kind: string
  sampleVars: Record<string, string>
  recipient: string
}

export interface SendTestResponse {
  messageId: string
}

/** Sample-var form state seeded from each kind's declared examples. */
export function initialSampleVars(template: SendableEmail): Record<string, string> {
  return Object.fromEntries(template.sampleVars.map((v) => [v.name, v.example]))
}
